import { render } from "./HomeSummary.vue?vue&type=template&id=4ced3742"
import script from "./HomeSummary.vue?vue&type=script&lang=js"
export * from "./HomeSummary.vue?vue&type=script&lang=js"

import "./HomeSummary.vue?vue&type=style&index=0&id=4ced3742&lang=scss"
script.render = render

export default script